import { ConnectorCannotDeleteReason } from 'features/connectors/domain/connector-cannot-delete-reason';
import { VcareConnectorData } from 'features/connectors/domain/vcare-connector-data';
import OrganisationUnit from 'features/organisation/domain/models/organisation-unit';

export interface Connector {
  id?: string;
  type: ConnectorType;
  name: string;
  note?: string;
  lastCommunicationDate?: Date;
  certificateExpiryDate?: Date;
  organisationUnits: OrganisationUnit[];
  vcareConnectorData?: VcareConnectorData;
  cannotDeleteReason?: ConnectorCannotDeleteReason;
  status?: ConnectorStatus;
}

export enum ConnectorType {
  Unknown = 'Unknown',
  NedapOns = 'NedapOns',
  Vcare = 'Vcare',
}

export enum ConnectorStatus {
  online = 'Online',
  offline = 'Offline',
}
